
import { APIData } from '../constants';
import useRest from './base/useRest';

const preffix = "products-services";

// ACCOUNTS OR PRODUCTS
export const useProductsServices = (options:APIData) => {
    return useRest(`${preffix}/`, options);
};